import { ArrowRightIcon } from '@heroicons/react/20/solid';
import { ReactComponent as CommingSoon } from '../assets/coming-soon.svg';
import { ReactComponent as WorkpapersLogo } from '../assets/cimplico-logo.svg';

function MaintenancePage(): JSX.Element {
    return (
        <div className="h-screen w-screen flex items-center flex-col pt-16">
            <div className=" flex gap-x-2 mr-8 mb-8">
                <div className="text-indigo-600">
                    <WorkpapersLogo />
                </div>
                <h1 className="text-gray-800 text-base leading-4 font-semibold w-[101px]" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                    Cimplico Workpapers
                </h1>
            </div>
            <h1 className="text-4xl text-gray-800 font-bold">We&apos;ll be back soon!</h1>
            <p className="text-gray-600 text-sm text-center mt-1">
                Cimplico Workpapers is undergoing scheduled maintenance and will be back up shortly.
                <br />
                For updates please go&nbsp;
                <a
                    href="https://cimplico.statuspage.io/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-indigo-600 inline-flex items-center gap-1"
                >
                    here <ArrowRightIcon className="h-4 w-4" />
                </a>
            </p>
            <CommingSoon />
        </div>
    );
}

export default MaintenancePage;
